<!--
 * @Description: 混凝土结算
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-11 13:51:13
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="tabtop">
          <div v-for="(item, index) in navlist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
            <div v-if="currenindex !== index + 1 && currenindex !== index + 2 && index !== 2" class="hr"></div>
          </div>
        </div>
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav" style="padding-top:18px">
              <el-form :inline="true" label-width="110px">
                <!-- 待结算搜索条件 -->
                <el-form-item v-if="currenindex == 1">
                  <span slot="label">工程名称</span>
                  <div style="width:300px;height:36px;display:flex;">
                    <div :title="searchText"
                      style="width:216px;padding:0 10px;border-bottom: 1px solid #bbb;margin-right:5px;" class="ellipsis">
                      {{ searchText }}</div>
                    <el-button class="bottom_all_two" @click="search = true">选择</el-button>
                  </div>
                </el-form-item>
                <el-form-item v-if="currenindex == 1">
                  <span slot="label">收货时间</span>
                  <el-date-picker v-model="datePicker" style="height:36px" type="datetimerange" unlink-panels
                    align="right" start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </el-form-item>
                <!-- 已结算搜索条件 -->
                <el-form-item v-if="currenindex == 2">
                  <span slot="label">工程名称</span>
                  <div style="width:300px;height:36px;display:flex;">
                    <div :title="searchTexted"
                      style="width:216px;padding:0 10px;border-bottom: 1px solid #bbb;margin-right:5px;" class="ellipsis">
                      {{ searchTexted }}</div>
                    <el-button class="bottom_all_two" @click="search = true">选择</el-button>
                  </div>
                  <!-- <el-input v-model="tableParam.engineeringName" placeholder="请输入"></el-input> -->
                </el-form-item>
                <!-- <el-form-item v-if="currenindex==2">
                  <span slot="label">客户名称</span>
                  <el-input v-model="tableParam.roadwork" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item v-if="currenindex==2">
                  <span slot="label">结算单号</span>
                  <el-input v-model="tableParam.statementNo" placeholder="请输入"></el-input>
                </el-form-item> -->
                <el-form-item v-if="currenindex == 2">
                  <span slot="label">签收时间</span>
                  <el-date-picker v-model="datePicker" style="height:36px" type="datetimerange" unlink-panels
                    align="right" start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['00:00:00', '00:00:00']"
                    value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </el-form-item>
                <!-- 结算单的搜索条件 -->
                <el-form-item v-if="currenindex == 3">
                  <span slot="label">工程名称</span>
                  <div style="width:300px;height:36px;display:flex;">
                    <div :title="searchTextput"
                      style="width:216px;padding:0 10px;border-bottom: 1px solid #bbb;margin-right:5px;" class="ellipsis">
                      {{ searchTextput }}</div>
                    <el-button class="bottom_all_two" @click="search = true">选择</el-button>
                  </div>
                </el-form-item>
                <el-form-item v-if="currenindex == 3">
                  <span slot="label">提交时间</span>
                  <el-date-picker v-model="datePicker" style="height:36px" type="datetimerange" unlink-panels
                    align="right" start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['00:00:00', '00:00:00']"
                    value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button v-if="currenindex == 1" icon="el-icon-search" size="medium" class="bottom_all"
                    @click="(tableParam.page = 1), pagesgettableData(), saveSearchVal()">查 询</el-button>
                  <el-button v-if="currenindex !== 1" icon="el-icon-search" size="medium" class="bottom_all"
                    @click="(tableParam.page = 1), gettableData(), saveSearchVal()">查 询</el-button>
                  <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重
                    置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card" :style="currenindex !== 1 ? 'padding-top:10px' : ''">
            <div v-show="currenindex == 1" class="card_nav">
              <div>
                <el-button v-if="ButtonList.findIndex(res => (res.buttonValue == 'SHENGCJSD')) !== -1" size="small"
                  class="bottom_three" :disabled="generate.logisticsVoList.length == 0"
                  @click="statements">生成结算单</el-button>
                <el-button size="small" class="bottom_three" @click="concreteSettle">混凝土结算价</el-button>
              </div>
              <div>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table ref="table" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                border stripe style="width: 100%" :data="tableData" tooltip-effect="dark"
                @selection-change="pageshandleSelectionChange">
                <el-table-column v-if="currenindex == 1" align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                    <template slot-scope="scope">
                      <!-- <span v-if="item.label == '状态'">
                        <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
                        <span v-if="scope.row.enable == 1" style="color: #00a754">启用</span>
                      </span> -->
                      <div v-if="item.label == '泵类型'">
                        <div v-for="(item, index) in scope.row.detList" :key="index">
                          {{ item.pouringWay || item.pumpType }}
                        </div>
                      </div>
                      <div v-else-if="item.label == '结算单编号'" class="table_link" @click="show(scope.row)">
                        {{ scope.row[item.prop] }}
                      </div>
                      <div v-else-if="item.label == '臂长(米)'">
                        <div v-for="(item, index) in scope.row.detList" :key="index">
                          {{ item.height }}
                        </div>
                      </div>

                      <div v-else-if="item.label == '泵单价(元/方)'">
                        <div v-for="(item, index) in scope.row.detList" :key="index">
                          {{ item.pumpPrice }}
                        </div>
                      </div>
                      <div v-else-if="item.label == '浇筑量(方)'">
                        <div v-for="(item, index) in scope.row.detList" :key="index">
                          {{ item.num }}
                        </div>
                      </div>
                      <div v-else-if="item.label == '减扣量'">
                        <el-input v-if="currenindex == 1" v-model="scope.row.adjustMum" size="mini" style="width: 100px;"
                          clearable oninput="value=value.replace(/^([0-9-]\d*\.?\d{0,2})?.*$/,'$1')"></el-input>
                        <span v-else>{{ scope.row.adjustMum }}</span>
                        <!-- <div v-for="(item, index) in scope.row.detList" :key="index">
                          {{ item.num }}
                        </div> -->
                      </div>
                      <div v-else-if="item.label == '泵送费用(元)'">

                        <div v-for="(item, index) in scope.row.detList" :key="index">
                          {{ item.pumpCost }}
                        </div>
                      </div>
                      <div v-else-if="item.label == '结算时间段'">
                        {{ scope.row.startTime }}至{{ scope.row.endTime }}
                      </div>
                      <span v-else-if="item.label == '审核状态'">
                        {{ scope.row.auditStatus == 1 ? '待提交' : scope.row.auditStatus == 2 ? '审核中' : scope.row.auditStatus
                          == 3 ? '通过' : '未通过' }}
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-button v-if="scope.row.auditStatus == 3 && scope.row.supplierConfirm != 2" size="mini"
                          class="bottom_all_two" @click="userSubmit(scope.row)">
                          发送
                        </el-button>
                        <el-button v-if="scope.row.auditStatus == 1 || scope.row.auditStatus == 4" size="mini"
                          class="bottom_all_two"
                          @click="$router.push({ name: 'sign_concrete', query: { id: scope.row.statementNo, type: 1 } })">提交审核</el-button>
                      </span>
                      <span v-else-if="item.label == '客户确认'">
                        {{ scope.row.supplierConfirm == 1 ? '待查看' : scope.row.supplierConfirm == 2 ? '同意' :
                          scope.row.supplierConfirm == 3 ? '拒绝' : '未发送' }}
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <!-- <el-pagination :current-page.sync="tableParam.page" :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000,'全部']"
            layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange"
            @current-change="currenindex !== 1 ? gettableData() : pagesgettableData()">
            <el-select v-model="curElPage" class="pageSelectContainer" placeholder="请选择" size="mini" @change="changeSizes">
              <el-option v-for="item in optionsPage" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-pagination> -->
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000, '全部']" layout="prev,pager,slot,next,jumper"
            :total="total" @size-change="sizeChange"
            @current-change="currenindex !== 1 ? gettableData() : pagesgettableData()">
            <el-select v-model="curElPage" class="pageSelectContainer" placeholder="请选择" size="mini"
              @change="changeSizes">
              <el-option v-for="item in optionsPage" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
            @click="currenindex !== 1 ? gettableData() : pagesgettableData()">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 选择供应商合同 -->
    <el-dialog v-dialogDrag :visible.sync="search" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择工程</span>
      <div class="dialoginfo">
        <div style="position: relative;height:40px;">
          <div style="display: flex;justify-content: space-around;">
            <div>
              <span style="color: red;">*</span> 销售员：
              <el-select ref="selection1" v-model="sallerId" filterable style="width: 130px;" clearable>
                <el-option v-for="(item, index) in salespersons" :key="index" :label="item.saller"
                  :value="item.sallerId"></el-option>
              </el-select>
            </div>
            <div style="">
              <span style="color: red;">*</span> 预算员：
              <el-select ref="selection1" v-model="budgetPersonId" filterable style="width: 130px;" clearable>
                <el-option v-for="(item, index) in estimateClerks" :key="index" :label="item.budgetPerson"
                  :value="item.budgetPersonId"></el-option>
              </el-select>
            </div>
            <div style="">
              工程名称：
              <el-input v-model="engineeringName" size="mini" style="width: 130px;" clearable></el-input>
              <el-button size="mini" class="bottom_all but1" style="margin-left: 10px;"
                @click="initsearch()">搜索</el-button>
            </div>
          </div>

        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="searchData" tooltip-effect="dark" @row-click='setradio'>
          <el-table-column align="center" label="选择">
            <template slot-scope="scope">
              <el-radio :value="searchradio" :label="JSON.stringify(scope.row)">{{ '' }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column align="center" label="建委合同号" prop="ccContractNo"></el-table-column>
          <el-table-column align="center" label="合同号" prop="contractNo"></el-table-column>
          <el-table-column align="center" label="工程名称" prop="engineeringName"></el-table-column>
          <el-table-column align="center" label="销售员" prop="saller"></el-table-column>
          <el-table-column align="center" label="预算员" prop="budgetPerson"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="search = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitsearch()">确
          定</el-button>
      </span>
    </el-dialog>
    <!-- 结算单 -->
    <el-dialog v-dialogDrag :visible.sync="billDeta" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">混凝土结算单</span>
      <div ref="html" style="padding:10px 20px;height:600px;" class="scroll">
        <div class="bill_top">
          <span><span class="text">结算工程：</span>{{ billDetails.engineeringName }}</span>
          <span><span class="text">合同单位：</span>{{ billDetails.collaborationUnitId }}</span>
          <span><span class="text">结算时间：</span>{{ billDetails.startTime }}至{{ billDetails.endTime }}</span>
          <span><span class="text">结算单编号：</span>{{ billDetails.statementNo }}</span>
        </div>
        <!-- <div style="padding:10px 0">
          <span v-if="UserInfo.adminStatus == 1" style="color: #ff0000">公司</span>
          <el-select v-if="UserInfo.adminStatus == 1" ref="selection1" v-model="companyId"
            style="padding-left:15px;padding-right:40px"
            @change="setstationIdlist(), $nextTick(() => { company = $refs.selection1.selectedLabel })">
            <el-option v-for="item in companylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span style="color: #ff0000">站点名称</span>
          <el-select ref="selection2" v-model="stationId" style="padding-left:15px"
            @change="get_simple_organizationFun(stationId), $nextTick(() => { stationName = $refs.selection2.selectedLabel })">
            <el-option v-for="item in stationIdlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div> -->
        <div class="bill_title">产品结算</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="productDetailList" tooltip-effect="dark">
          <el-table-column label="时间段" align="center" width="175">
            <template slot-scope="scope"> {{ scope.row.startTime }} - {{ scope.row.endTime }} </template>
          </el-table-column>
          <el-table-column label="产品名称" align="center" prop="productName">
            <template slot-scope="scope"> {{ scope.row.productName }} </template>
          </el-table-column>
          <el-table-column label="签收数量（方）" align="center" prop="signNum"></el-table-column>
          <el-table-column label="车数（车）" align="center">
            <template slot-scope="scope"> {{ scope.row.carNum }} </template>
          </el-table-column>
          <el-table-column label="产品组合" align="center" prop="productNameCompose"></el-table-column>
          <el-table-column label="单价（元/m³）" align="center" prop="composePrice"></el-table-column>
          <el-table-column label="强度等级单价（元/m³）" align="center" prop="strenghGradePrice">
            <template slot-scope="a">
              <el-input v-model="a.row.strenghGradePrice" :disabled="a.row.sureSpecailGrade != 1" style="width:100%"
                type="Number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="特添材料单价（元/m³）" align="center" prop="fillerMaterialPrice">
            <template slot-scope="a">
              <el-input v-model="a.row.fillerMaterialPrice" :disabled="a.row.sureSpecailGrade != 1" style="width:100%"
                type="Number"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column label="合同单价（元/m³）" align="center" prop="basicPeice"></el-table-column> -->
          <el-table-column label="结算单价（元/m³）" align="center" prop="settlePrice"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settleAccount"></el-table-column>
        </el-table>
        <div class="combined">
          小计：签收数量【{{ combined(productDetailList, '产品结算') }}】，结算金额【{{ combined1(productDetailList, '产品结算') }}】</div>
        <div class="bill_title">泵送结算</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="pumpDetailList" tooltip-effect="dark">
          <el-table-column label="泵类型" align="center" prop="pumpName"></el-table-column>
          <el-table-column label="生效时间" align="center" prop="effectTime"></el-table-column>
          <el-table-column label="泵送数量（方）" align="center" prop="pumpNum"></el-table-column>
          <el-table-column label="补差方量（方）" align="center" prop="repairDifferNum"></el-table-column>
          <el-table-column label="结算单价（元）" align="center">
            <template slot-scope="a">
              <el-input v-model="a.row.settlePrice" disabled style="width:100%" type="Number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="结算金额（元）" align="center">
            <template slot-scope="a">
              {{ a.row.settlementAccount }}
            </template>
          </el-table-column>
        </el-table>
        <div class="combined">小计：泵送数量【{{ combined(pumpDetailList, '泵送结算') }}】，结算金额【{{ combined1(pumpDetailList, '泵送结算')
        }}】
        </div>
        <div class="bill_title">超高层增加费</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="highStoreyDetailList" tooltip-effect="dark">
          <el-table-column label="高度（米）" align="center" prop="highInterval"></el-table-column>
          <el-table-column label="超高层方量（方）" align="center" prop="quantity"></el-table-column>
          <el-table-column label="结算单价（元）" align="center">
            <template slot-scope="a">
              <el-input v-model="a.row.settilmentPrice" disabled style="width:100%" type="Number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="结算金额（元）" align="center">
            <template slot-scope="a">
              {{ a.row.settlementAccount }}
            </template>
          </el-table-column>
        </el-table>
        <div class="combined">小计：超高层方量【{{ combined(highStoreyDetailList, '超高层增加费') }}】，结算金额【{{
          combined1(highStoreyDetailList, '超高层增加费')
        }}】
        </div>
        <div v-if="dataType == 1" class="bill_title">运输费用（车补）</div>
        <el-table v-if="dataType == 1" :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="transportDetailList"
          tooltip-effect="dark">
          <el-table-column label="单价（元/车）" align="center" prop="price"></el-table-column>
          <el-table-column label="数量（车）" align="center" prop="quality"></el-table-column>
          <el-table-column label="结算金额（元）" align="center">
            <template slot-scope="a">
              {{ a.row.settleAcount }}
            </template>
          </el-table-column>
        </el-table>
        <div v-if="dataType == 2" class="bill_title">运输费用（方补）</div>
        <el-table v-if="dataType == 2" :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="transportDetailList"
          tooltip-effect="dark">
          <el-table-column label="运输方量（方）" align="center" prop="quality"></el-table-column>
          <el-table-column label="补差单价（元）" align="center" prop="price"></el-table-column>
          <el-table-column label="结算金额（元）" align="center">
            <template slot-scope="a">
              {{ a.row.settleAcount }}
            </template>
          </el-table-column>
        </el-table>
        <div class="bill_title">特殊条款</div>
        <div><el-input v-model="spetailTerm" style="width:100%" placeholder="请输入特殊条款"></el-input></div>
        <div class="bill_title">
          结算补差费用
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="chooseSettlement">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            选择补差数据
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="settlementCompensate" tooltip-effect="dark">
          <el-table-column label="时间段" align="center" width="400" prop="startandendtime"></el-table-column>
          <el-table-column label="产品名称" align="center" prop="productName"></el-table-column>
          <el-table-column label="签收数量（方）" align="center" prop="signNum"></el-table-column>
          <el-table-column label="原结算单价（元/m³）" align="center" prop="settlePrice"></el-table-column>
          <el-table-column label="补差单价（元/m³）" align="center" prop="compensatePrice"></el-table-column>
          <el-table-column label="结算补差金额（元）" align="center" prop="compensateAccount">
            <template slot-scope="a">
              {{ a.row.compensateAccount }}
            </template>
          </el-table-column>
        </el-table>
        <div class="combined">小计：签收数量【{{ combined(settlementCompensate, '结算补差') }}】，结算补差金额【{{
          combined1(settlementCompensate, '结算补差') }}】
        </div>
        <div class="bill_title">
          调整金额
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem1()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="settlementAdjust" tooltip-effect="dark">
          <el-table-column label="站点" align="center">
            <template slot-scope="scope">
              <el-select ref="stationName" v-model="scope.row.stationId" style="width: 100%" placeholder="请选择调整类型"
                @change="
                  $nextTick(() => {
                    scope.row.stationName = $refs.stationName.selectedLabel;
                  })
                  ">
                <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
                  :value="item.stationId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整类型" align="center">
            <template slot-scope="scope">
              <el-select ref="deductionType1" v-model="scope.row.adjustTypeId" style="width: 100%" placeholder="请选择调整类型"
                @change="
                  $nextTick(() => {
                    scope.row.adjustType = $refs.deductionType1.selectedLabel;
                  })
                  ">
                <el-option v-for="item in deductionTypes" :key="item.id" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调增/调减" align="center" prop="type">
            <template slot-scope="scope">
              <el-select ref="type" v-model="scope.row.addOrReduce" style="width: 100%" placeholder="请选择">
                <el-option :key="1" label="调增" :value="1"></el-option>
                <el-option :key="0" label="调减" :value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整金额" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.adjustAmount" placeholder="请输入" style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.adjustAmount = $regExp.checkNum(scope.row.adjustAmount)"
                @blur="scope.row.adjustAmount = $regExp.blurCheckNum(scope.row.adjustAmount)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否影响开票" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.influenceInvoice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="border-top: 0px" class="combined">小计：结算金额【{{ combined5(1) }}】元</div>
        <div class="bill_title">结算合计</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="settlementTotal" tooltip-effect="dark">
          <el-table-column label="工程" align="center" prop="engineeringName"></el-table-column>
          <el-table-column label="合同签订主体" align="center" prop="collaborationUnit"></el-table-column>
          <el-table-column label="产品费用（元）" align="center" prop="productCost"></el-table-column>
          <el-table-column label="泵送费用（元）" align="center" prop="pumpCost"></el-table-column>
          <el-table-column label="超高层增加费（元）" align="center" prop="highStoreyCost"></el-table-column>
          <el-table-column label="小方量运输费用（元）" align="center" prop="qualityTransportCost"></el-table-column>
          <el-table-column label="结算补差费用（元）" align="center" prop="makeCost"></el-table-column>
          <el-table-column label="调整金额（元，不影响开票）" align="center" prop="adjustCostNoEffect"></el-table-column>
          <el-table-column label="调整金额（元，影响开票）" align="center" prop="adjustCostEffect"></el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="settlementAccount"></el-table-column>
          <el-table-column label="开票金额（元）" align="center" prop="invoicingCost"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" style="display: flex;" class="dialog-footer">
        <div v-if="daochu">
          <el-button class="bottom_all" @click="downloadHandler()">导出</el-button>
        </div>
        <div style="flex: 1;">
          <el-button class="bottom_all_two" @click="billDeta = false; settlementAdjust = []">取 消</el-button>
          <el-button class="bottom_all" style="margin-left: 24px;" @click="combinedSubmit(0)">保 存</el-button>
        </div>

      </span>
    </el-dialog>
    <!-- 查看结算单 -->
    <el-dialog v-dialogDrag :visible.sync="billDeta1" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">混凝土结算单</span>
      <div style="padding:10px 20px;height:600px;" class="scroll">
        <div class="bill_top">
          <span><span class="text">结算工程：</span>{{ billDetails1.engineeringName }}</span>
          <span><span class="text">合同单位：</span>{{ billDetails1.customer }}</span>
          <span><span class="text">公司：</span>{{ billDetails1.company }}</span>
          <span><span class="text">站点名称：</span>{{ billDetails1.stationName }}</span>
          <span><span class="text">结算时间：</span>{{ billDetails1.startTime }}至{{ billDetails1.endTime }}</span>
          <span><span class="text">结算单编号：</span>{{ billDetails1.statementNo }}</span>
        </div>
        <div class="bill_title">产品结算</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="billDetails1.map.beton" tooltip-effect="dark">
          <el-table-column label="产品名称" align="center" prop="itemName"></el-table-column>
          <el-table-column label="签收数量（方）" align="center" prop="adjustSignForNum"></el-table-column>
          <el-table-column label="产品组合" align="center" prop="requirement"></el-table-column>
          <el-table-column label="基本单价（元）" align="center" prop="unitPrice"></el-table-column>
          <el-table-column label="结算单价（方）" align="center" prop="statementUnitPrice">
          </el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="realPay">
          </el-table-column>
        </el-table>
        <div class="combined">小计：签收数量【{{ combined(billDetails1.map.beton) }}】，结算金额【{{ combined1(billDetails1.map.beton)
        }}】
        </div>
        <div class="bill_title">泵送结算</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="billDetails1.map.pump" tooltip-effect="dark">
          <el-table-column label="泵类型" align="center" prop="itemName"></el-table-column>
          <el-table-column label="臂长&高度（米）" align="center" prop="height"></el-table-column>
          <el-table-column label="泵送数量（方）" align="center" prop="adjustSignForNum"></el-table-column>
          <el-table-column label="基本单价(元/方)" align="center" prop="unitPrice"></el-table-column>
          <el-table-column label="结算单价（元）" align="center" prop="statementUnitPrice">
          </el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="realPay">
          </el-table-column>
        </el-table>
        <div class="combined">小计：泵送数量【{{ combined(billDetails1.map.pump) }}】，结算金额【{{ combined1(billDetails1.map.pump) }}】
        </div>
        <div class="bill_title">小方量结算</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="billDetails1.map.small" tooltip-effect="dark">
          <el-table-column label="补差方量(方)" align="center" prop="adjustSignForNum"></el-table-column>
          <el-table-column label="基本单价（元/方）" align="center" prop="unitPrice"></el-table-column>
          <el-table-column label="结算单价（元）" align="center" prop="statementUnitPrice">
          </el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="realPay">
          </el-table-column>
        </el-table>
        <div class="combined">小计：补差方量【{{ combined(billDetails1.map.small) }}】，结算金额【{{ combined1(billDetails1.map.small)
        }}】
        </div>
        <div class="bill_title">结算合计</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="totalList1" tooltip-effect="dark">
          <el-table-column label="工程" align="center" prop="name"></el-table-column>
          <el-table-column label="合同签订主体" align="center" prop="name"></el-table-column>
          <el-table-column label="产品费用（元）" align="center" prop="name"></el-table-column>
          <el-table-column label="泵送费用（元）" align="center" prop="name"></el-table-column>
          <el-table-column label="超高层增加费（元）" align="center" prop="name"></el-table-column>
          <el-table-column label="小方量运输费用（元）" align="center" prop="name"></el-table-column>
          <el-table-column label="结算补差费用（元）" align="center" prop="name"></el-table-column>
          <el-table-column label="调整金额（元，不影响开票）" align="center">
            <template slot-scope="a">
              {{ combined(billDetails1.map[a.row.code]) }}
            </template>
          </el-table-column>
          <el-table-column label="调整金额（元，影响开票）" align="center">
            <template slot-scope="a">
              {{ combined(billDetails1.map[a.row.code]) }}
            </template>
          </el-table-column>
          <el-table-column label="结算金额（元）" align="center">
            <template slot-scope="a">
              {{ combined1(billDetails1.map[a.row.code]) }}
            </template>
          </el-table-column>
          <el-table-column label="开票金额（元）" align="center">
            <template slot-scope="a">
              {{ combined1(billDetails1.map[a.row.code]) }}
            </template>
          </el-table-column>
        </el-table>
        <div class="combined">小计：{{ combined4(totalList1) }}</div>
      </div>
      <span slot="footer" class="dialog-footer" style="display:flex;justify-content: space-between;">
        <div>
          <el-button class="bottom_all_two" @click="downloadLink">打印结算单</el-button>
          <el-button v-if="billDetails1.auditStatus == 1" class="bottom_all_two"
            @click="combinedSubmit(3)">提交审核</el-button>
        </div>
        <div>
          <el-button class="bottom_all_two" @click="billDeta1 = false">取 消</el-button>
        </div>
      </span>
    </el-dialog>
    <!--选择发送的人员-->
    <!-- <el-dialog v-dialogDrag :visible.sync="userDeta" width="620px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">请选择接收账号</span>
      <div style="padding:0 10px">
        <el-checkbox-group v-model="userarr">
          <template v-for="(item,index) in useroptons">
            <el-checkbox :key="index" style="line-height:26px" :label="item.id">{{item.name}}</el-checkbox>
          </template>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="userDeta=false">取 消</el-button>
        <el-button class="bottom_all" :disabled="userarr.length==0" style="margin-left: 24px" @click="userSubmit()">发 送</el-button>
      </span>
    </el-dialog> -->
    <!-- 获取补差数据 -->
    <el-dialog v-dialogDrag :visible.sync="compensate" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">结算补差</span>
      <div class="dialoginfo">
        <div style="position: relative;height:40px;">
          <div style="display: flex;justify-content: left;">
            <div style="">
              签收时间段
              <el-date-picker v-model="compensate_datePicker" style="height:36px" type="datetimerange" unlink-panels
                align="right" start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['00:00:00', '00:00:00']"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              <el-button size="mini" class="bottom_all but1" style="margin-left: 10px;"
                @click="compensatesearch({ engineeringId: billDetails.engineeringId }, compensate_datePicker)">搜索</el-button>
            </div>
          </div>

        </div>
        <el-table ref="multipleTable" :row-key="rowKey" :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="compensateList"
          tooltip-effect="dark" @selection-change="compensateSelectionChange">
          <el-table-column align="center" type="selection" :reserve-selection="true"></el-table-column>
          <el-table-column align="center" label="车牌号" prop="carNo"></el-table-column>
          <el-table-column align="center" label="产品名称" prop="productName"></el-table-column>
          <el-table-column align="center" label="签收时间" prop="signTime"></el-table-column>
          <el-table-column align="center" label="签收数量（方）" prop="signNum"></el-table-column>
          <el-table-column align="center" label="原结算单价（元/m³）" prop="settlePrice"></el-table-column>
          <el-table-column align="center" label="补差单价（元/m³）" prop="compensatePrice"></el-table-column>
          <el-table-column align="center" label="补差金额（元）" prop="compensateAccount"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="bottom_all_two" @click="compensate = false;">取 消</el-button> -->
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitcompensate()">确
          定</el-button>
      </span>
    </el-dialog>

    <el-dialog v-dialogDrag :visible.sync="errorMap" width="700px" :close-on-click-modal="true">
      <span slot="title" class="dialog-title">生成结算单错误提示</span>
      <div class="dialoginfo">
        <div>
          <div v-for="(item, index) in errorMapList" :key="index">
            <div style="font-size: 40rpx;font-weight:bold;">{{ item.name }}:</div>
            <div v-for="(v, i) in item.list" :key="i">
              <div class="errbox">{{ (i + 1) + '.' + v }}</div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="errorMap = false;">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryPage1, queryPage2, queryPage3, get_engineering_list, generate_statement_detail,
  save_statementde_tail,
  update_statementde_tail,
  get_statement_detail,
  // get_users,
  update_status,
  Download,
  querySallerOrBudget,
  generate_statement_compensate
} from "@/api/wise/concrete.js";
import { get_detail_code } from '@/api/basedata/concrete.js'
import { getUserInfo } from "@/utils/auth.js";
import { _debounce } from "@/utils/utils.js";
import { getcompany, getUserAutList, get_simple_organization, uploadFile } from "@/api/common.js";
import { get_station_list } from "@/api/smart/stocksake.js";
import {
  informClient
} from "@/api/wise/Wise_contactsbusiness/Wise_contactsbusiness.js";
import html2canvas from 'html2canvas';
export default {
  mixins: [mixin],
  data() {
    return {
      //分页
      optionsPage: [
        {
          label: "10条/页",
          value: 10,
        },
        {
          label: "20条/页",
          value: 20,
        },
        {
          label: "30条/页",
          value: 30,
        },
        {
          label: "40条/页",
          value: 40,
        },
        {
          label: "50条/页",
          value: 50,
        },
        {
          label: "100条/页",
          value: 100,
        },
        {
          label: "200条/页",
          value: 200,
        },
        {
          label: "500条/页",
          value: 500,
        },
        {
          label: "1000条/页",
          value: 1000,
        },
        {
          label: "全部",
          value: 100000,
        },
      ],
      curElPage: 100000, //默认每页显示20条
      errorMapList: [],
      errorMap: false,
      companyId: '',
      company: '',
      companylist: [],
      stationId: '',
      stationName: '',
      stationIdlist: [],
      /*表格数据*/
      queryPage: '',
      download: Download,
      table: [],
      table1: [
        { label: "工程名称", width: "auto", prop: "engineeringName", status: true },
        { label: "合同签订主体", width: "120", prop: "collaborationUnit", status: true },
        { label: "生产站点", width: "120", prop: "stationName", status: true },
        { label: "订单号", width: "auto", prop: "orderNo", status: true },
        { label: "运输号", width: "120", prop: "logisticsNo", status: true },
        { label: "车牌号", width: "auto", prop: "carNo", status: true },
        { label: "产品名称", width: "120", prop: "productName", status: true },
        { label: "票单名称", width: "auto", prop: "ticketName", status: true },
        { label: "票面量(方)", width: "120", prop: "ticketNum", status: true },
        { label: "客户收货时间", width: "120", prop: "signTime", status: true },
        { label: "签收量(方)", width: "120", prop: "signNum", status: true },
        { label: "减扣量", width: "120", prop: "adjustMum", status: true },
        { label: "浇筑方式", width: "120", prop: "pumpMethod", status: true },
        // { label: "单价(元/方)", width: "120", prop: "unitPrice", status: true },
        // { label: "混凝土费用(元)", width: "120", prop: "betonCost", status: true },
        // { label: "小方量补差（方）", width: "120", prop: "smallQuantitiesDelta", status: true },
        // { label: "单价（元/方）", width: "120", prop: "smallQuantitiesPrice", status: true },
        // { label: "小方量运费（元）", width: "120", prop: "smallQuantitiesCost", status: true },
        // { label: "泵类型", width: "120", prop: "", status: true },
        // { label: "臂长(米)", width: "120", prop: "", status: true },
        // { label: "浇筑量(方)", width: "120", prop: "", status: true },
        // { label: "单价(元/方)", width: "120", prop: "", status: true },
        // { label: "泵送费用(元)", width: "120", prop: "", status: true },
        { label: "结算单价(元)", width: "120", prop: "settlePrice", status: false },
        // { label: "结算单号", width: "120", prop: "settlementAmount", status: true },
      ],
      table2: [
        { label: "结算单编号", width: "320", prop: "statementNo", status: true },
        { label: "工程名称", width: "140", prop: "engineeringName", status: true },
        { label: "合同签订主体", width: "140", prop: "collaborationUnit", status: true },
        { label: "结算时间段", width: "310", prop: "", status: true },
        { label: "结算金额", width: "140", prop: "statementAmount", status: true },
        { label: "提交时间", width: "160", prop: "createTime", status: true },
        { label: "审核状态", width: "140", prop: "auditStatus", status: true },
        { label: "操作", width: "120", prop: "", status: true },
        { label: "客户确认", width: "120", prop: "supplierConfirm", status: true },
      ],
      pagesType: 0,
      /**导航栏*/
      navlist: [
        {
          value: "待结算",
          id: 1,
        },
        {
          value: "已结算",
          id: 2,
        },
        {
          value: "结算单",
          id: 3,
        },
      ],
      currenindex: 1,
      search: false,
      searchradio: '',
      searchText: '',
      searchTexted: '',
      datePicker: [],
      billDetails: {
        map: {
          beton: [],
          pump: [],
          small: []
        }
      },
      totalList: [
        { name: '混凝土', code: 'beton' },
        { name: '泵送', code: 'pump' },
        { name: '小方量运输', code: 'small' }
      ],
      generate: {
        logisticsVoList: []
      },
      billDeta: false,
      searchData: [],
      low: {},
      billDeta1: false,
      billDetails1: {
        map: {
          beton: [],
          pump: [],
          small: []
        }
      },
      totalList1: [
        { name: '混凝土', code: 'beton' },
        { name: '泵送', code: 'pump' },
        { name: '小方量运输', code: 'small' }
      ],
      UserInfo: '',
      userDeta: false,
      useroptons: [],
      userarr: [],
      engineeringName: '',

      // 6.12结算迭代
      salespersons: [//销售员列表
        {
          sallerId: "24215072540856320",
          saller: "销售员82"
        }
      ], //销售员
      estimateClerks: [//预算员列表
        {
          budgetPersonId: "24216362201255936",
          budgetPerson: "预算员81"
        }
      ],//预算员
      sallerId: '',//选择的销售ID
      budgetPersonId: '',//选择的预算员ID
      settlementAdjust: [],
      deductionTypes: [
        { itemName: '产品费用', id: '1' },
        { itemName: '泵送费用', id: '2' },
        { itemName: '超高层增加费', id: '3' },
        { itemName: '小方量运输费', id: '4' },
        { itemName: '特殊条款', id: '5' },
      ],
      showCardNav: true,
      highStoreyDetailList: [],
      transportDetailList: [],
      pumpDetailList: [],
      productDetailList: [],
      spetailTerm: '',
      dataType: 1,
      compensate_datePicker: [],
      compensate: false,
      compensateList: [],//结算补差
      settlementCompensate: [],
      settlementCompensate1: [],
      settlementTotal: [{//结算总计
        adjustCostEffect: 0,//调整金额(影响开票)
        adjustCostNoEffect: 0,//调整金额(不影响开票)
        collaborationUnit: "",//合同签订主体
        engineeringName: "",//工程名
        invoicingCost: 0,//开票金额
        makeCost: 0,//结算补差费用
        productCost: 0,//产品费用
        highStoreyCost: 0,//超高层费用
        pumpCost: 0,//泵送费用
        qualityTransportCost: 0,//小方量费用
        settlementNo: "",//结算单编号
        settlementAccount: 0
      }],
      //合并表格
      columnArr: ["startandendtime", '', '', "settlePrice", "compensatePrice"],
      spanArr: [], //临时组
      spanData: [], // 组合的合并组
      updateFlag: false,
      settlementCompensateCopy: [],
      daochu: false,
      statementNo: '',
      stationList: [],
    };
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam.pageSize = 100000
    this.tableParam = { ...this.tableParam, engineeringId: '', startTime: '', endTime: '', settleStatus: 0 };
    this.querySallerOrBudget()
    this.get_detail_code();
    this.UserInfo = getUserInfo();
    if (this.UserInfo.adminStatus == 1) {
      /**通过typeId为公司类型id查询所有公司 */
      getcompany({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then((res) => {
        this.companylist = res.data;
      });
    } else {
      this.stationIdlist = await getUserAutList(true)
    }

    //搜索缓存
    if (sessionStorage.getItem('searchval')) {
      var data = JSON.parse(sessionStorage.getItem('searchval'))
      let text = JSON.parse(sessionStorage.getItem('searchradio'))
      this.searchText = data.searchText
      this.searchTextput = data.searchTextput
      this.searchTexted = data.searchTexted
      this.tableParam.engineeringId = text.engineeringId
      this.generate.engineeringId = text.engineeringId
      this.generate.engineeringName = text.engineeringName
      this.generate.customer = text.roadwork
      this.generate.contractId = text.engineeringId
    }
    if (sessionStorage.getItem('datePicker')) {
      this.datePicker = JSON.parse(sessionStorage.getItem('datePicker'))
      this.tableParam.startTime = this.datePicker[0]
      this.tableParam.endTime = this.datePicker[1]
      this.generate.startTime = this.tableParam.startTime
      this.generate.endTime = this.tableParam.endTime
    }
  },
  watch: {
    datePicker() {
      if (this.datePicker) {
        this.tableParam.startTime = this.datePicker[0]
        this.tableParam.endTime = this.datePicker[1]
      } else {
        this.tableParam.startTime = ''
        this.tableParam.endTime = ''
      }
    },
    currenindex: {
      handler() {
        this.tableData = []
        this.datePicker = []
        this.tableParam = this.$options.data().tableParam
        if (this.currenindex == 1) {
          this.tableParam.pageSize = 100000
          this.searchText = ''
          this.tableParam.settleStatus = 0
          this.table = this.table1;
          this.queryPage = queryPage1
        }
        if (this.currenindex == 2) {
          this.tableParam.pageSize = 10
          this.curElPage = 10
          this.searchTexted = ''
          this.table = this.table1;
          this.queryPage = queryPage2
          //搜索缓存
          if (sessionStorage.getItem('searchval')) {
            var data = JSON.parse(sessionStorage.getItem('searchval'))
            let text = JSON.parse(sessionStorage.getItem('searchradio'))
            this.searchText = data.searchText
            this.searchTextput = data.searchTextput
            this.searchTexted = data.searchTexted
            this.tableParam.engineeringId = text.engineeringId
            this.generate.engineeringId = text.engineeringId
            this.generate.engineeringName = text.engineeringName
            this.generate.customer = text.roadwork
            this.generate.contractId = text.engineeringId
          }
          if (sessionStorage.getItem('datePicker')) {
            this.datePicker = JSON.parse(sessionStorage.getItem('datePicker'))
            this.tableParam.startTime = this.datePicker[0]
            this.tableParam.endTime = this.datePicker[1]
            this.generate.startTime = this.tableParam.startTime
            this.generate.endTime = this.tableParam.endTime
          }
          this.gettableData()
        }
        if (this.currenindex == 3) {
          this.tableParam.pageSize = 10
          this.curElPage = 10
          this.searchTexted = ''
          this.table = this.table2;
          this.queryPage = queryPage3
          //搜索缓存
          if (sessionStorage.getItem('searchval')) {
            var data1 = JSON.parse(sessionStorage.getItem('searchval'))
            let text = JSON.parse(sessionStorage.getItem('searchradio'))
            this.searchText = data1.searchText
            this.searchTextput = data1.searchTextput
            this.searchTexted = data1.searchTexted
            this.tableParam.engineeringId = text.engineeringId
            this.generate.engineeringId = text.engineeringId
            this.generate.engineeringName = text.engineeringName
            this.generate.customer = text.roadwork
            this.generate.contractId = text.engineeringId
          }
          this.gettableData()
        }
      },
      deep: false,
      immediate: true,
    },
    tableData() {
      if (this.tableData.length !== 0 && this.currenindex == 1) {
        this.$refs.table.toggleAllSelection()
        let text = JSON.parse(this.searchradio)
        this.generate.startTime = this.tableParam.startTime
        this.generate.endTime = this.tableParam.endTime
        this.generate.engineeringId = text.engineeringId
        this.generate.engineeringName = text.engineeringName
        this.generate.customer = text.roadwork
        this.generate.contractId = text.engineeringId
      }
    },
    /**结算合计*/
    tatol: {
      handler() {
        this.settotalList();
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    tatol() {
      return {
        settlementCompensate: this.settlementCompensate,
        settlementAdjust: this.settlementAdjust,
        billDetails: this.billDetails
      };
    },
  },
  methods: {
    get_detail_code() {
      get_detail_code({ code: 'concreteAdjust' }).then(res => {
        if (res.code == 1001) {
          this.deductionTypes = res.data.items
        }
      })
    },
    changeSizes() {
      this.tableParam.pageSize = this.curElPage;
      this.gettableData()
    },
    downloadHandler() {
      this.$Download(Download, { statementNo: this.statementNo });
    },
    handleEdit(e) {
      console.log(e)
      let value = e.replace(/^([0-9-]\d*\.?\d{0,2})?.*$/, '$1'); // 只能输入-和数字
      // value = value.replace(/^\d/g, ""); // 不能以数字开头
      // // value = value.replace(/\-{2,}/g, "-"); // -只能保留一个
      // // value = value.replace(/(\d)\-/g, "$1"); // 数字后面不能接-，不能出现类似-11-2,12-，11-23
      // value = value.replace(/(-)0+/g, "$1"); // 不能出现-0,-001,-0001类似
      // value = value.replace(/(-\d{15})\d*/, '$1') // 最多保留15位整数
      console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeee", value)
    },
    saveSearchVal() {
      sessionStorage.setItem('datePicker', JSON.stringify(this.datePicker))
    },
    chooseSettlement() {
      var _this = this
      _this.compensate = true;
      if (_this.updateFlag && _this.currenindex == 3) {
        setTimeout(() => {
          _this.$refs.multipleTable.clearSelection();
        }, 50);
        setTimeout(() => {
          if (_this.compensateList.length > 0) {
            _this.compensateList.forEach(row => {
              if (row.sureUse == 1) { // 根据条件找出需要回显的数据 根据自己后端的条件来写 一般都是布尔值
                _this.$refs.multipleTable.toggleRowSelection(row, true);
              }
            });
          }
        }, 600)
        _this.updateFlag = false
      }
      if (_this.updateFlag && _this.currenindex == 1) {
        _this.$refs.multipleTable.clearSelection();
        _this.updateFlag = false
      }
    },
    /**结算合计*/
    settotalList: _debounce(function () {
      this.settlementTotal[0].adjustCostEffect = this.combined5(2);
      this.settlementTotal[0].adjustCostNoEffect = this.combined5(3);
      this.settlementTotal[0].collaborationUnit = this.billDetails.collaborationUnit;
      this.settlementTotal[0].engineeringName = this.billDetails.engineeringName;
      this.settlementTotal[0].makeCost = this.combined1(this.settlementCompensate, '结算补差');
      this.settlementTotal[0].productCost = this.combined1(this.productDetailList, '产品结算');
      this.settlementTotal[0].highStoreyCost = this.combined1(this.highStoreyDetailList, '超高层增加费');
      this.settlementTotal[0].pumpCost = this.combined1(this.pumpDetailList, '泵送结算');
      this.settlementTotal[0].settlementNo = '';
      this.settlementTotal[0].settlementAccount = this.combinedall(1);
      this.settlementTotal[0].invoicingCost = this.combinedall(2);
      if (this.transportDetailList.length != 0) {
        this.settlementTotal[0].qualityTransportCost = this.transportDetailList[0].settleAcount;
      }
    }),
    /*结算金额合计type:1结算金额2开票金额 */
    combinedall(type) {
      let num = 0;
      let row = this.settlementTotal[0];
      let settlementAccount = 0;
      if (type == 1) {
        num = settlementAccount + Number(row.adjustCostEffect) + Number(row.adjustCostNoEffect) + Number(row.makeCost) + Number(row.productCost) + Number(row.highStoreyCost) + Number(row.pumpCost) + Number(row.qualityTransportCost)
      } else if (type == 2) {
        num = settlementAccount + Number(row.adjustCostEffect) + Number(row.adjustCostNoEffect) + Number(row.makeCost) + Number(row.productCost) + Number(row.highStoreyCost) + Number(row.pumpCost) + Number(row.qualityTransportCost) - Number(row.adjustCostNoEffect)
      }
      return num.toFixed(2);
    },
    /**调整金额*/
    addItem1() {
      let obj = {
        stationId: '',
        stationName: '',
        adjustType: '',
        adjustTypeId: '',
        addOrReduce: '',
        adjustAmount: '',
        influenceInvoice: 0,//1影响，0不影响
        statementNo: '',
        remark: '',
      };
      this.settlementAdjust.push(obj);
    },
    delItem1(index) {
      this.settlementAdjust.splice(index, 1);
    },
    compensateSelectionChange(val) {
      console.log('compensateSelectionChange', val)
      this.settlementCompensate1 = [...new Set(JSON.parse(JSON.stringify(val)))]
      console.log('compensateSelectionChange', this.settlementCompensate1)
    },
    submitcompensate() {
      var newArr = []
      var flagend = []
      // var arrOld = []
      // if (this.updateFlag) {
      //   arrOld = JSON.parse(JSON.stringify(this.settlementCompensateCopy))
      //   this.settlementCompensate1.push(...new Set(arrOld))
      // }
      this.settlementCompensate1.forEach(e => {
        e.startandendtime = e.compensateStartTime + '-' + e.compensateEndTime
      })
      if (this.settlementCompensate1.length == 1) {
        newArr.push(this.settlementCompensate1[0])
      } else if (this.settlementCompensate1.length > 1) {
        for (let i = 0; i < this.settlementCompensate1.length; i++) {
          if (i == this.settlementCompensate1.length - 1) {
            newArr.forEach(e => {
              if (e.compensateStartTime == this.settlementCompensate1[i].compensateStartTime &&
                e.compensateEndTime == this.settlementCompensate1[i].compensateEndTime &&
                e.productName == this.settlementCompensate1[i].productName &&
                e.settlePrice == this.settlementCompensate1[i].settlePrice &&
                e.compensatePrice == this.settlementCompensate1[i].compensatePrice) {
                flagend.push(1)
              } else {
                flagend.push(2)
              }
            })
            if (!flagend.includes(1)) {
              newArr.push(this.settlementCompensate1[i])
            }
            break;
          }
          for (let j = i + 1; j < this.settlementCompensate1.length; j++) {
            if (this.settlementCompensate1[i].compensateStartTime == this.settlementCompensate1[j].compensateStartTime &&
              this.settlementCompensate1[i].compensateEndTime == this.settlementCompensate1[j].compensateEndTime &&
              this.settlementCompensate1[i].productName == this.settlementCompensate1[j].productName &&
              this.settlementCompensate1[i].settlePrice == this.settlementCompensate1[j].settlePrice &&
              this.settlementCompensate1[i].compensatePrice == this.settlementCompensate1[j].compensatePrice
            ) {
              this.settlementCompensate1[i].signNum = this.settlementCompensate1[i].signNum + this.settlementCompensate1[j].signNum
              this.settlementCompensate1[i].compensateAccount = this.settlementCompensate1[i].compensateAccount + this.settlementCompensate1[j].compensateAccount
              this.settlementCompensate1[i].detailId = this.settlementCompensate1[i].detailId + ',' + this.settlementCompensate1[j].detailId
              var flag = []
              newArr.forEach(e => {
                if (e.compensateStartTime == this.settlementCompensate1[i].compensateStartTime &&
                  e.compensateEndTime == this.settlementCompensate1[i].compensateEndTime &&
                  e.productName == this.settlementCompensate1[i].productName &&
                  e.settlePrice == this.settlementCompensate1[i].settlePrice &&
                  e.compensatePrice == this.settlementCompensate1[i].compensatePrice) {
                  flag.push(1)
                } else {
                  flag.push(2)
                }
              })
              if (!flag.includes(1)) {
                newArr.push(this.settlementCompensate1[i])
              }
            } else {
              var flags = []
              newArr.forEach(e => {
                if (e.compensateStartTime == this.settlementCompensate1[i].compensateStartTime &&
                  e.compensateEndTime == this.settlementCompensate1[i].compensateEndTime &&
                  e.productName == this.settlementCompensate1[i].productName &&
                  e.settlePrice == this.settlementCompensate1[i].settlePrice &&
                  e.compensatePrice == this.settlementCompensate1[i].compensatePrice) {
                  flags.push(1)
                } else {
                  flags.push(2)
                }
              })
              if (!flags.includes(1)) {
                newArr.push(this.settlementCompensate1[i])
              }
            }
          }
        }
      }
      this.settlementCompensate = [...new Set(newArr)]
      // this.getSpanArr(this.settlementCompensate)
      console.log('this.settlementCompensate,', this.settlementCompensate)
      this.compensate = false
    },
    getSpanArr(data) {
      this.spanData = [];
      this.columnArr.forEach((element) => {
        let contactDot = 0;
        this.spanArr = [];
        data.forEach((item, index) => {
          if (index === 0) {
            this.spanArr.push(1);
          } else {
            if (item[element] === data[index - 1][element]) {
              this.spanArr[contactDot] += 1;
              this.spanArr.push(0);
            } else {
              contactDot = index;
              this.spanArr.push(1);
            }
          }
        });
        this.spanData.push(this.spanArr);
      });
      console.log('this.spanData', this.spanData)
    },
    // arraySpanMethod({ row, column, rowIndex, columnIndex }) {
    //   console.log(row)
    //   console.log(column.property, '---', rowIndex, '----', columnIndex)
    //   // if (this.columnArr.includes(column.property)) {
    //   //   if (this.spanData[columnIndex][rowIndex]) {
    //   //     return {
    //   //       rowspan: this.spanData[columnIndex][rowIndex],
    //   //       colspan: 1,
    //   //     };
    //   //   } else {
    //   //     return {
    //   //       rowspan: 0,
    //   //       colspan: 0,
    //   //     };
    //   //   }
    //   // }
    // },
    rowKey(row) {
      return row.detailId
    },
    /* 获取结算补差 */
    compensatesearch(data, time) {
      var _this = this
      let datas
      if (time) {
        datas = { ...data, startTime: time[0], endTime: time[1] }
      } else {
        datas = data
      }
      generate_statement_compensate(datas).then(res => {
        _this.compensateList = res.data
        _this.compensateList.forEach(e => {
          if (e.sureUse == 1) {
            _this.settlementCompensate1.push(e)
            console.log('_this.settlementCompensate1--------', _this.settlementCompensate1)
          }
        })
      })
    },
    /* 获取销售员/预算员*/
    querySallerOrBudget() {
      querySallerOrBudget().then(res => {
        console.log(res)
        if (res.code == 1001) {
          this.salespersons = res.data.saller
          this.estimateClerks = res.data.bufget
          console.log(this.salespersons)
          console.log(this.estimateClerks)
        }
      })
    },
    downloadLink() {
      this.$Download(this.download, { statementNo: this.low.statementNo })
    },
    /**通过站点查询公司 */
    get_simple_organizationFun(id) {
      get_simple_organization({ id: id }).then((res) => {
        this.companyId = res.data.id
        this.company = res.data.name
      });//查询站点所属公司
    },
    /*根据公司获取站点*/
    setstationIdlist() {
      get_station_list({ parentId: this.fromDate.companyId }).then((res) => {
        this.stationIdlist = res.data;
      });
    },
    /**小计量*/
    combined(arr, nameType) {
      let num = 0
      console.log(arr, nameType)
      if (this.billDeta1 || this.billDeta) {
        if (arr.length > 0) {
          arr.forEach(res => {
            if (nameType == '产品结算') {
              num = Number(res.signNum) + num
            } else if (nameType == '泵送结算') {
              num = Number(res.pumpNum) + num
            } else if (nameType == '超高层增加费') {
              num = Number(res.quantity) + num
            } else if (nameType == '结算补差') {
              num = Number(res.signNum) + num
            }
          })
        }
      }
      return num?.toFixed(2)
    },
    /**小计金额*/
    combined1(arr, nameType) {
      console.log(arr)
      let num = 0
      if (this.billDeta1 || this.billDeta) {
        if (arr.length > 0) {
          arr.forEach(res => {
            if (nameType == '产品结算') {
              num = Number(res.settleAccount) + num
            } else if (nameType == '泵送结算') {
              num = Number(res.settlementAccount) + num
            } else if (nameType == '超高层增加费') {
              num = Number(res.settlementAccount) + num
            } else if (nameType == '结算补差') {
              num = Number(res.compensateAccount) + num
            }
          })
        }
      }
      return num?.toFixed(2)
    },
    /*调整金额合计type:1全部,2影响开票金额合计,3不影响开票金额合计 */
    combined5(type) {
      let num = 0;
      this.settlementAdjust.forEach(res => {
        if (type == 1) {
          num = res.addOrReduce ? num + Number(res.adjustAmount) : num - Number(res.adjustAmount);
        } else if (type == 2) {
          if (res.influenceInvoice == 1) {
            num = res.addOrReduce ? num + Number(res.adjustAmount) : num - Number(res.adjustAmount);
          }
        } else if (type == 3) {
          if (res.influenceInvoice == 0) {
            num = res.addOrReduce ? num + Number(res.adjustAmount) : num - Number(res.adjustAmount);
          }
        }
      });
      return num.toFixed(2);
    },
    /**结算总计算
     * @param {Array} arr 为显示的数据，并提供billDetails数据里的keyand b.
    */
    combined3(arr) {
      console.log(arr)
      let num = 0
      if (this.billDeta1 || this.billDeta) {
        // arr.forEach(res => {
        //   num = this.combined1(this.billDetails.map[res.code]) * 1 + num
        // })
      }
      return num?.toFixed(2)
    },
    combined4(arr) {
      console.log(arr)
      let num = 0
      if (this.billDeta1 || this.billDeta) {
        // arr.forEach(res => {
        //   num = this.combined1(this.billDetails1.map[res.code]) * 1 + num
        // })
      }
      return num?.toFixed(2)
    },
    /**
     * 保存结算单
     * @param {number} num 标识保存或提佳品审批 
     */
    combinedSubmit(num) {
      if (num == 3) {
        this.$router.push({ name: "sign_concrete", query: { id: this.low.statementNo, type: 1 } })
        return
      }
      let _this = this
      let data = new Object()
      new Promise(resolve => {
        html2canvas(_this.$refs.html).then((canvas) => {
          canvas.toBlob((blob) => {
            const file = new File([blob], '结算截图.jpg', { type: 'image/jpg' });
            const params = new FormData();
            params.append('file', file);
            uploadFile(params).then(res => {
              if (res.code === 1001) {
                resolve(res.data.fileUrl)
              }
            })
          })
        })
      }).then(value => {
        console.log(value)
        var flag = []
        data.spetailTerm = _this.spetailTerm
        data.settlementAdjust = _this.settlementAdjust
        data.settlementCompensate = _this.settlementCompensate
        data.settlementTotal = _this.settlementTotal[0]
        _this.productDetailList.forEach(e => {
          if (e.sureSpecailGrade == 1) {
            if (Number(e.strenghGradePrice) + Number(e.fillerMaterialPrice) != Number(e.settlePrice)) {
              flag.push(3)
            }
            if ((e.strenghGradePrice && e.fillerMaterialPrice) || (e.strenghGradePrice && e.fillerMaterialPrice == 0)) {
              flag.push(1)
            } else {
              flag.push(2)
            }
          }
        })
        console.log(flag)
        if (flag.includes(3)) {
          return _this.$message.warning('您填写的强度等级单价和特添材料单价之和 与 结算单价不符，请重新填写')
        }
        if (flag.includes(2)) {
          return _this.$message.warning('存在强度等级单价或特添材料单价未填写，请填写后保存！')
        }
        data.productDetailList = _this.productDetailList
        data.pumpDetailList = _this.pumpDetailList
        data.transportDetailList = _this.transportDetailList[0]
        data.highStoreyDetailList = _this.highStoreyDetailList
        if (_this.billDetails.id) {
          data.statementNo = _this.billDetails.statementNo
          data.concreteSettlement = _this.billDetails
          data.concreteSettlement.statementAmount = _this.settlementTotal[0].settlementAccount
          update_statementde_tail(data).then(res => {
            if (res.code == 1001) {
              _this.$message.success('修改成功')
              _this.billDeta = false;
              _this.gettableData()
            }
          })
        } else {
          data.concreteSettlement = {
            collaborationUnit: _this.billDetails.collaborationUnit,
            collaborationUnitId: _this.billDetails.collaborationUnitId,
            engineeringId: _this.billDetails.engineeringId,
            engineeringName: _this.billDetails.engineeringName,
            startTime: _this.billDetails.startTime,
            endTime: _this.billDetails.endTime,
            statementAmount: _this.settlementTotal[0].settlementAccount,
            auditStatus: 1,
            supplierConfirm: 0,
            statementNo: '',
            id: _this.billDetails.id
          }
          save_statementde_tail(data).then(res => {
            if (res.code == 1001) {
              _this.$message.success('保存成功')
              _this.billDeta = false;
              _this.gettableData()
            }
          })
        }



      })
    },
    /*导航栏切换*/
    choose(num) {
      this.currenindex = num;
      if (num == 2) {
        this.table1[13].status = true;
      } else {
        this.table1[13].status = false;
      }
    },
    /**搜索条件单选选中*/
    setradio(data) {
      this.searchradio = JSON.stringify(data)
    },
    /**工程选择*/
    submitsearch() {
      let text = JSON.parse(this.searchradio)
      this.tableParam.engineeringId = text.engineeringId
      if (this.currenindex == 1) {
        this.searchText = (text.contractNo != null ? text.contractNo + '-' : '') + (text.roadwork != null ? text.roadwork + '-' : '') + text.engineeringName
        this.searchTexted = ''
        this.searchTextput = ''
      } else if (this.currenindex == 2) {
        this.searchTexted = (text.contractNo != null ? text.contractNo + '-' : '') + (text.roadwork != null ? text.roadwork + '-' : '') + text.engineeringName
        this.searchText = ''
        this.searchTextput = ''
      } else if (this.currenindex == 3) {
        this.searchTextput = (text.contractNo != null ? text.contractNo + '-' : '') + (text.roadwork != null ? text.roadwork + '-' : '') + text.engineeringName
        this.searchTexted = ''
        this.searchText = ''
      }
      sessionStorage.setItem('searchval', JSON.stringify({
        engineeringId: text.engineeringId,
        searchText: this.searchText,
        searchTextput: this.searchTextput,
        searchTexted: this.searchTexted,
      }))
      sessionStorage.setItem('searchradio', JSON.stringify(text))
      this.search = false
    },
    /**搜索条件*/
    initsearch() {
      let data = {
        sallerId: this.sallerId,//销售员id//筛选条件
        budgetPersonId: this.budgetPersonId,//预算员id//筛选条件
        engineeringName: this.engineeringName//筛选条件
      }
      get_engineering_list(data).then(res => {
        console.log(res)
        this.searchData = res.data
      })
    },
    /*重置数据*/
    init() {
      this.tableParam = this.$options.data().tableParam
      this.datePicker = []
      this.searchText = ''
      this.searchTexted = ''
      this.searchTextput = ''
      sessionStorage.removeItem('searchval')
      sessionStorage.removeItem('datePicker')
      // this.gettableData();
    },
    /**表格选中*/
    pageshandleSelectionChange(val) {
      this.generate.logisticsVoList = val
      this.generate.collaborationUnit = val[0].collaborationUnit
      this.generate.collaborationUnitId = val[0].collaborationUnitId
    },
    /**判断工程时间必传*/
    async pagesgettableData() {
      // if (this.tableParam.engineeringId && this.datePicker && this.datePicker.length !== 0) {
      if (this.datePicker && this.datePicker.length !== 0) {
        await this.gettableData()
        if (this.tableData.length > 0) {
          let row = this.tableData[0]
          let div = `<table>异常物流数量：` + row.err.errorNum + `</table>`
          // row.err.reason?.forEach((v) => {
          //   div += `<div style="word-break: break-all;word-wrap: break-word;font-weight: 100;">` + v + `</div>`
          // })
          this.$notify({
            title: '工程：' + row.engineeringName,
            dangerouslyUseHTMLString: true,
            message: '<strong>' + div + '</strong>',
            position: 'bottom-right',
            duration: 0
          });
        }
        return
      }
      this.$message({
        message: '警告哦，请先选择供应商和时间段后查询',
        type: 'warning'
      });
    },
    /**生成结算单*/
    statements() {
      let _this = this
      _this.daochu = false;
      if (!_this.tableParam.engineeringId) {
        return _this.$message.warning('生产结算单请先选择工程！')
      }
      _this.transportDetailList = []
      _this.settlementCompensate = []
      _this.errorMapList = []
      console.log(_this.generate)
      generate_statement_detail(_this.generate).then((res) => {
        if (res.code == 1001) {
          if (res.data.sureError == 1) {
            if (res.data.errorMap.pumoMethos) {
              _this.errorMapList.push({
                name: '泵送费用',
                list: res.data.errorMap.pumoMethos
              })
            }
            if (res.data.errorMap.highStorey) {
              _this.errorMapList.push({
                name: '超高层费用',
                list: res.data.errorMap.highStorey
              })
            }
            if (res.data.errorMap.productPrice) {
              _this.errorMapList.push({
                name: '产品费用',
                list: res.data.errorMap.productPrice
              })
            }
            _this.errorMap = true;
          } else {
            _this.billDetails = res.data
            _this.spetailTerm = res.data.spetailTerm
            _this.productDetailList = res.data.productDetailList  //产品
            _this.pumpDetailList = res.data.pumpDetailList //泵送
            _this.highStoreyDetailList = res.data.highStoreyDetailList //超高层
            _this.compensatesearch({ engineeringId: res.data.engineeringId })
            if (res.data.transportDetailList) {
              _this.transportDetailList.push(res.data.transportDetailList) //运输
              _this.dataType = res.data.transportDetailList.dataType
            }
            this.stationList = res.data.stationList
            _this.billDeta = true
            _this.updateFlag = true

          }
        }
      })
    },
    concreteSettle() {
      this.$router.push({ name: 'concretePrice' })
    },
    show(low) {
      let _this = this
      _this.low = low;
      _this.daochu = true;
      // var newArr = []
      _this.transportDetailList = []
      _this.settlementCompensate = []
      this.statementNo = low.statementNo
      get_statement_detail({ settlementNo: low.statementNo }).then(res => {
        if (res.code == 1001) {
          _this.billDetails = res.data.concreteSettlement
          _this.productDetailList = res.data.productDetailList  //产品
          _this.productDetailList.forEach(e => {
            if (e.historyLogistics !== null) {
              e.carNum = e.historyLogistics.length
            } else {
              e.carNum = 0
            }
          })
          _this.spetailTerm = res.data.concreteSettlement.spetailTerm
          _this.pumpDetailList = res.data.pumpDetailList //泵送
          _this.highStoreyDetailList = res.data.highStoreyDetailList //超高层
          res.data.settlementCompensate.forEach((e) => {
            e.startandendtime = e.compensateStartTime + '-' + e.compensateEndTime
          })
          this.settlementCompensate = res.data.settlementCompensate
          this.settlementCompensateCopy = JSON.parse(JSON.stringify(res.data.settlementCompensate))
          // for (let i = 0; i < res.data.settlementCompensate.length; i++) {
          //   for (let j = i + 1; j < res.data.settlementCompensate.length; j++) {
          //     if (res.data.settlementCompensate[i].compensateStartTime == res.data.settlementCompensate[j].compensateStartTime &&
          //       res.data.settlementCompensate[i].compensateEndTime == res.data.settlementCompensate[j].compensateEndTime &&
          //       res.data.settlementCompensate[i].productName == res.data.settlementCompensate[j].productName &&
          //       res.data.settlementCompensate[i].settlePrice == res.data.settlementCompensate[j].settlePrice &&
          //       res.data.settlementCompensate[i].compensatePrice == res.data.settlementCompensate[j].compensatePrice
          //     ) {
          //       res.data.settlementCompensate[i].signNum = res.data.settlementCompensate[i].signNum + res.data.settlementCompensate[j].signNum
          //       res.data.settlementCompensate[i].compensateAccount = res.data.settlementCompensate[i].compensateAccount + res.data.settlementCompensate[j].compensateAccount
          //       res.data.settlementCompensate[i].detailId = res.data.settlementCompensate[i].detailId + ',' + res.data.settlementCompensate[j].detailId
          //       newArr.push(res.data.settlementCompensate[i])
          //       var flag = []
          //       newArr.forEach(e => {
          //         if (e.compensateStartTime == res.data.settlementCompensate[i].compensateStartTime &&
          //           e.compensateEndTime == res.data.settlementCompensate[i].compensateEndTime &&
          //           e.productName == res.data.settlementCompensate[i].productName &&
          //           e.settlePrice == res.data.settlementCompensate[i].settlePrice &&
          //           e.compensatePrice == res.data.settlementCompensate[i].compensatePrice) {
          //           flag.push(1)
          //         } else {
          //           flag.push(2)
          //         }
          //       })
          //       if (!flag.includes(1)) {
          //         newArr.push(this.settlementCompensate1[i])
          //       }
          //     }
          //   }
          // }
          // _this.settlementCompensate = newArr //超高层
          // _this.getSpanArr(_this.settlementCompensate)
          console.log('this.settlementCompensate,', _this.settlementCompensate)
          _this.settlementAdjust = res.data.settlementAdjust //超高层
          _this.stationList = res.data.stationList
          if (res.data.transportDetailList) {
            _this.dataType = res.data.transportDetailList.dataType
            _this.transportDetailList.push(res.data.transportDetailList) //运输
          }
          _this.compensatesearch({ engineeringId: res.data.concreteSettlement.engineeringId, statementNo: res.data.concreteSettlement.statementNo })
          _this.billDeta = true
          _this.updateFlag = true

        }
      })
    },
    /**结算单发给供应商*/
    // send(low) {
    //   this.low = low
    //   this.userarr = []
    //   this.useroptons = []
    //   get_users({ engineeringId: low.engineeringId }).then(res => {
    //     console.log(res.data)
    //     if (res.data.length == 0) {
    //       this.$message({
    //         message: '暂无相关人员',
    //         type: 'warning'
    //       });
    //       return
    //     }
    //     this.useroptons = res.data.map(res => ({ id: res.userId, name: res.userName }))
    //     this.userDeta = true
    //   })
    // },
    async userSubmit(low) {
      this.$confirm('确认发送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(async () => {
        let json = {
          type: 3,
          settlementId: low.id,
          settlementNo: low.statementNo,
          times: low.startTime + '-' + low.endTime,
          money: low.statementAmount,
          applyForTime: low.submitTime,
          imgUrl: low.picture,
          contractId: low.engineeringId
        }
        // let arr = this.userarr.map(res => (new useritem(res)))
        await informClient(json).then(res => {
          if (res.code == 1001) {
            update_status({ statementNo: low.statementNo, statusType: 2, supplierConfirm: 1 }).then(() => { })
            this.$message({
              message: '发送成功',
              type: 'success'
            });
            this.gettableData()
            this.userDeta = false
          }
        })
      })
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      if (this.currenindex == 3) {
        this.pagesgettableData()
      } else {
        this.gettableData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {
  padding: 20px 20px 0 20px;
  max-height: 400px;
  overflow: auto;
}

.tabtop {
  width: 571px;
}

.el-input,
.el-select {
  width: 240px;
}

/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}

.bill_top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  line-height: 40px;

  .text {
    font-weight: 600;
    color: #000;
  }
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.bill_subtitle {
  padding: 20px 0;

  >span {
    padding-right: 20px;
  }

  .text {
    color: #000;
  }
}

.errbox {
  margin-top: 20rpx;
  border-bottom: 1px solid #ccc;
}

.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}
</style>
